import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  @Input() aboutMessage:any = 'LoreIpsum';
  constructor() { }

  ngOnInit(): void {
  }

}
